export default __webpack_public_path__ + "static/media/delete.8d9316cc.svg";